import z from 'zod';
import {phoneNumberSchema} from "../common/phoneNumberSchema";

const userAccountCreateSchema = z.object({
    username: z.string()
        .min(3, {message: "Uživatelské jméno musí mít alespoň 3 znaky"})
        .max(50, {message: "Uživatelské jméno může mít maximálně 50 znaků"}),
    email: z.string()
        .email("Neplatný email")
        .min(5, {message: "Email musí mít alespoň 5 znaků"})
        .max(100, {message: "Email může mít maximálně 100 znaků"}),
    firstName: z.string()
        .min(1, {message: "Jméno nesmí být prázdné"})
        .max(50, {message: "Jméno může mít maximálně 50 znaků"}),
    lastName: z.string()
        .min(1, {message: "Příjmení nesmí být prázdné"})
        .max(50, {message: "Příjmení může mít maximálně 50 znaků"}),
    phoneNumber: phoneNumberSchema
        .optional().or(z.literal("")),
});

type UserAccountCreateSchema = z.infer<typeof userAccountCreateSchema>;

export {userAccountCreateSchema, type UserAccountCreateSchema};